export const onConfirmDialogConfirm = () => ({
  widget: 'entries',
  type: 'onConfirmDialogConfirm',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/entries/actions/onConfirmDialogConfirm.js